import styles from "../../../styles/Components/trade-assistant/assistant/SignalMoreInfo.module.css";
import useSuggestedSignal from "../../../hooks/useSuggestedSignal";
import { useSelector } from "react-redux";
import { normalizeLiveTimeframe } from "../../../redux/live-suggestion/liveSuggestionSlice";

function SignalMoreInfo({ data = {} }) {
  const liveTimeframe = useSelector((state) => state.liveSuggestion.liveTimeframe);
  const liveLabel = normalizeLiveTimeframe(liveTimeframe);
  const symbol = data?.SYMBOL_NAME;
  const category = data?.CATEGORY_INFO?.category || "the open category";
  const goodness = Number(data?.CATEGORY_INFO?.goodness);
  const goodnessLine = Number.isFinite(goodness)
    ? ` Goodness is ${Math.round(goodness)}%.`
    : "";
  const strength = Number(data?.SIGNAL_STRENGTH);
  const strengthLine =
    Number.isFinite(strength) && strength > 0
      ? ` Strength is ${Math.round(strength)} out of 5.`
      : "";

  const { aiData, liveData } = useSuggestedSignal({
    coin: symbol,
    oppositeSignal: "ai",
  });
  const pivotSide = String(liveData?.tradeType || "").split("/")[0];
  const pivotText = pivotSide === "Buy" || pivotSide === "Sell" ? pivotSide : "No pivot";

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.headerBox}>
          <span className={styles.headerBoxLabel}>Category call:</span>
          <div className={styles.headerBoxValue}>
            <span style={{ color: `${aiData?.signalColor}` }}>
              {aiData?.signal}
            </span>
            <span>{aiData?.date}</span>
          </div>
        </div>
        <div className={styles.headerBox}>
          <span className={styles.headerBoxLabel}>Pivot ({liveLabel}):</span>
          <div className={styles.headerBoxValue}>
            <span style={{ color: `${liveData?.signalColor}` }}>
              {pivotText}
            </span>
            <span>{liveData?.date}</span>
          </div>
        </div>
      </div>

      <div className={styles.oneHourDetails}>
        <span className={styles.label}>Category: {category}</span>
        <p>
          This is the {category} call on the assistant row.{strengthLine}{goodnessLine} Hold
          means this category did not open a Buy or Sell.
        </p>
      </div>

      <div>
        <span className={styles.label}>Pivot on {liveLabel}</span>
        <p style={{ marginBottom: 0 }}>
          This looks for a turn on the {liveLabel} chart. It is not the category call.
        </p>
      </div>
      {/*<h4 className={styles.header}>Signal Details</h4>*/}

      {/*<ul className={styles.infoList}>*/}
      {/*  <li className={styles.infoItem}>*/}
      {/*    <span className={styles.label}>Signal Strength:</span>*/}
      {/*    <span className={styles.info}>({signalStrength}%)</span>*/}
      {/*  </li>*/}

      {/*  <li className={styles.infoItem}>*/}
      {/*    <span className={styles.label}>Expected Return:</span>*/}
      {/*    <span className={styles.info}>{expectedReturn}</span>*/}
      {/*  </li>*/}

      {/*  <li className={styles.infoItem}>*/}
      {/*    <span className={styles.label}>Recommended Size%:</span>*/}
      {/*    <span className={styles.info}>*/}
      {/*      {Math.trunc(suggestedAmount * 100)}%*/}
      {/*    </span>*/}
      {/*  </li>*/}

      {/*  <li className={styles.infoItem}>*/}
      {/*    <span className={styles.label}>Suggested Leverage:</span>*/}
      {/*    <span className={styles.info}>{suggestedLeverage}</span>*/}
      {/*  </li>*/}

      {/*  <li className={styles.infoItem}>*/}
      {/*    <span className={styles.label}>Subcategory:</span>*/}
      {/*    <span className={styles.info}>{subcategory}</span>*/}
      {/*  </li>*/}

      {/*  <li className={styles.infoItem}>*/}
      {/*    <span className={styles.label}>Name:</span>*/}
      {/*    <span className={styles.info}>{name}</span>*/}
      {/*  </li>*/}

      {/*  <li className={styles.infoItem}>*/}
      {/*    <span className={styles.label}>Description:</span>*/}
      {/*    <span className={styles.info}>{description}</span>*/}
      {/*  </li>*/}
      {/*</ul>*/}
    </div>
  );
}

export default SignalMoreInfo;
